import * as I18n from 'circe/I18n';
import { NAME as APP_NAME, ROUTES as PRODUCT_TYPES_ROUTES } from 'domain/productType/constants';

export const NAME = `${APP_NAME}/PRODUCT_TYPES`;

export const REDUCER_NAME = 'productTypes';

export const FORM_NAME = 'CREATE_PRODUCT_TYPE';

export const ROUTES = {
  ROOT: `${PRODUCT_TYPES_ROUTES.ROOT}/create`,
};

export const TAGS = [
  { label: I18n.str('grayCement', 'Gray Cement'), value: 'division:cement' },
  {
    label: I18n.str('whiteCement', 'White Cement'),
    value: 'division:white cement',
  },
  { label: I18n.str('masheedGate', 'Masheed Gate'), value: 'division:gate' },
  {
    label: I18n.str('masheedGateCement', 'Masheed Gate Cement'),
    value: 'gate:cement',
  },
  {
    label: I18n.str('cementReplacement', 'Cement Replacement'),
    value: 'division:cement replacement',
  },
];
